import { render, staticRenderFns } from "./IndexForm.vue?vue&type=template&id=f32c31e0&scoped=true&"
import script from "./IndexForm.vue?vue&type=script&lang=js&"
export * from "./IndexForm.vue?vue&type=script&lang=js&"
import style0 from "./IndexForm.vue?vue&type=style&index=0&id=f32c31e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32c31e0",
  null
  
)

export default component.exports